"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sourcesType = exports.sourcesDataType = exports.sourceMetadataType = exports.sourceType = void 0;
const prop_types_1 = require("prop-types");
exports.sourceType = (0, prop_types_1.shape)({
  name: prop_types_1.string,
  url: prop_types_1.string.isRequired,
  agencyname: prop_types_1.string.isRequired,
  lastupdated: prop_types_1.string
});
exports.sourceMetadataType = (0, prop_types_1.shape)({
  agencyname: prop_types_1.string.isRequired,
  source: prop_types_1.string,
  sourceURL: prop_types_1.string.isRequired,
  sourceName: prop_types_1.string
});
exports.sourcesDataType = (0, prop_types_1.shape)({
  sources: (0, prop_types_1.arrayOf)(exports.sourceType),
  metadata: exports.sourceMetadataType
});
exports.sourcesType = (0, prop_types_1.shape)({
  agencyname: prop_types_1.string.isRequired,
  sources: (0, prop_types_1.arrayOf)(exports.sourceType)
});